import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import { useMemoizedFn } from 'ahooks'
import { message } from 'antd'
import { homeNSFWState } from 'Store/home'
import { userState } from 'Store/user'
import { loginModalOpenState } from 'Store/login'
import { updateUserNsfw } from 'Apis/user'
import { storageKey } from '@/constant/storage'

// 统一的 NSFW（Limitless）写入入口：乐观更新本地开关，
// 后端持久化失败时回滚，并同步 userState 与本地缓存。
export const useUpdateNsfw = () => {
  const [nsfw, setNsfw] = useRecoilState(homeNSFWState)
  const user = useRecoilValue(userState)
  const setUser = useSetRecoilState(userState)
  const setLoginOpen = useSetRecoilState(loginModalOpenState)

  const updateNsfw = useMemoizedFn(async (value: boolean) => {
    if (value === nsfw) return
    // 后端 user.nsfw 为权威源，未登录无法持久化：直接引导登录，
    // 不做乐观切换，避免 401 回滚 + 登录框 + 原始错误 toast 的体验回退。
    if (!user) {
      setLoginOpen(true)
      return
    }
    const prev = nsfw
    setNsfw(value)
    try {
      await updateUserNsfw(value)
      setUser((user) => {
        if (!user) return user
        const next = { ...user, nsfw: value }
        if (typeof window !== 'undefined') {
          localStorage.setItem(storageKey.USER, JSON.stringify(next))
        }
        return next
      })
    } catch (e) {
      setNsfw(prev)
      message.error(e instanceof Error ? e.message : String(e))
    }
  })

  return { updateNsfw }
}
